// This File is to allow for support with the new TL syntax, please keep this up to date as keys.txt changes,
// or if we want to update the text on a string
// we have a tool will that builds a legacyi18nObject using this mapping
// the tool is buildLegacyI18n in @bingads-webui-campaign/smart-i18n
// this file isn't exported, because we don't want the _TL_ syntax visible in the main exported code,
// as it breaks if not running through the bundler
export const legacyStrings = {
  'Choose...': _TL_('Choose...'),
  'Business location': _TL_('Business location'),
  'Business address': _TL_('Business address'),
  'Enter a new address...': _TL_('Enter a new address...'),
  'Select an existing address': _TL_('Select an existing address'),
  'Create a new address': _TL_('Create a new address'),
  'Please select or fill in to search': _TL_('Please select or fill in to search'),
  'User location': _TL_('User location'),
  'User location tooltip': _TL_('User location tooltip'),
  'Apply above business location to the user': _TL_('Apply above business location to the user'),
  'Country or region': _TL_('Country or region'),
  Remove: _TL_('Remove'),
  'Remove from Business address list': _TL_('Remove from Business address list'),
  ConsolidatedBillingV2_BillingGroupChangeAlert: _TL_('If you change the business location (country, state/province, city), this account will be removed from its current billing group. If you still want consolidated monthly invoicing for this account, please go to {{bold}}Billing settings{{/bold}} and add the account to an appropriate billing group.'),
  EInvoicing_StateValidationErrorMessage: _TL_('This field is not valid. Please check and re-enter.'),
  EInvoicing_ZipCodeValidationErrorMessage: _TL_('This field is not valid. Please check and re-enter.'),
  EInvoicing_GSTINValidationErrorMessage: _TL_('This GSTIN is not valid. Please check and re-enter your GSTIN.'),
  BusinessAddressSelector_Tooltip_AriaLabel: _TL_('Business address selector tooltip'),
  CurrencySelector_Tooltip_AriaLabel: _TL_('Currency selector tooltip'),
  Preferred_Timezone_Tooltip_AriaLabel: _TL_('Preferred time zone tooltip'),
  CCMTErrorNumber_GstInNumberAddressNotMatch: _TL_('The GSTIN you entered doesn’t match the business location on your registration. Please check your GSTIN and try again.'),
};
